// frontend/src/components/builder/PageCanvas.tsx
import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import DraggableItem from './DraggableItem';
import { CanvasItem } from '@/pages/BuilderPage';

interface PageCanvasProps {
  items: CanvasItem[];
  selectedInstanceId: string | null;
  onSelectItem: (id: string | null) => void;
  onRemoveItem: (id: string) => void;
  onUpdateProps?: (instanceId: string, newProps: any) => void;
  isPreviewMode?: boolean;
}

export default function PageCanvas({ items, selectedInstanceId, onSelectItem, onRemoveItem, onUpdateProps, isPreviewMode }: PageCanvasProps) {
  const { setNodeRef } = useDroppable({
    id: 'page-canvas',
  });

  return (
    <SortableContext items={items.map(item => item.instanceId)} strategy={verticalListSortingStrategy}>
      <div
        ref={setNodeRef}
        className="flex-1 min-h-full p-1 bg-gray-50 border-2 border-dashed border-gray-200 rounded-lg flex flex-col"
        onClick={() => onSelectItem(null)} // Click on canvas to deselect
      >
        {items.length === 0 && (
          <div className="flex-1 flex flex-col items-center justify-center text-gray-400 space-y-2 p-8 text-center">
            <p className="font-medium text-sm">Empty Screen</p>
            <p className="text-xs">Drag and drop components from the palette here</p>
          </div>
        )}
        {items.map((item) => (
          <DraggableItem
            key={item.instanceId}
            item={item}
            isSelected={item.instanceId === selectedInstanceId}
            onSelect={() => onSelectItem(item.instanceId)}
            onRemove={() => onRemoveItem(item.instanceId)}
            onUpdateProps={onUpdateProps}
            isPreviewMode={isPreviewMode}
          />
        ))}
      </div>
    </SortableContext>
  );
}
